// extracted by mini-css-extract-plugin
export default {"container":"Email_container__No2t-","icon":"Email_icon__iIVvk","content":"Email_content__VdaUn"};